import Model, { attr } from '@ember-data/model';
import { type ContactCustomPropertyInfo } from 'donor-elf-web/services/contacts-cache';

export interface LineItemCustomPropertyInfo {
  label: string;
  type: 'string' | 'number' | 'amount' | 'date' | 'boolean';
  distinct_values?: string[];
}

export default class FundSettingModel extends Model {
  @attr('date-only') pledgesDelinquentDate!: Date;
  @attr('boolean') lookingForwardExcludePledgesNoGifts!: boolean;
  @attr('boolean') lookingForwardExcludePledgesDelinquent!: boolean;
  @attr() defaultGroups: any;
  @attr('string') defaultGoalType?: string;
  @attr() availableGoalTypes?: any;
  @attr('date-only') ytdStartAt?: Date;
  @attr() lineItemCustomProperties?: LineItemCustomPropertyInfo[];
  @attr() contactCustomInfo?: {
    properties?: ContactCustomPropertyInfo[];
    date_labels?: { [label: string]: boolean };
  };
  @attr() contactStatuses?: string[]; // TODO: get rid of this and make Status a custom property
  @attr('boolean') cantMergeContactsWithDifferentEntities!: boolean;
  @attr() customReports?: string[];
  @attr() campaignsEnabled!: boolean;
}
